module.exports = __webpack_public_path__ + "img/pwa-install.9d67a754.png";